/**
 * 币种类型
 */
export var CurrencyType;
(function (CurrencyType) {
    /** 港币 HKD HK$ */
    CurrencyType["HKD"] = "HKD";
    /** 人民币 CNY ¥ */
    CurrencyType["CNY"] = "CNY";
    /** 日元 JPY JP¥ */
    CurrencyType["JPY"] = "JPY";
    /** 欧元 EUR € */
    CurrencyType["EUR"] = "EUR";
    /** 美元 USD $ */
    CurrencyType["USD"] = "USD";
    /** 澳门币 MOP MOP$ */
    CurrencyType["MOP"] = "MOP";
})(CurrencyType || (CurrencyType = {}));
/**
 * 币种码
 */
export var CurrencyCode;
(function (CurrencyCode) {
    /** 港币 HKD HK$ */
    CurrencyCode["HKD"] = "HK$";
    /** 人民币 CNY ¥ */
    CurrencyCode["CNY"] = "\u00A5";
    /** 日元 JPY JP¥ */
    CurrencyCode["JPY"] = "JP\u00A5";
    /** 欧元 EUR € */
    CurrencyCode["EUR"] = "\u20AC";
    /** 美元 USD $ */
    CurrencyCode["USD"] = "$";
    /** 澳门币 MOP MOP$ */
    CurrencyCode["MOP"] = "MOP$";
})(CurrencyCode || (CurrencyCode = {}));
